function formatterDateAndHour(data: string) {
  const formatBrazilian = new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })
  const formatedDate = formatBrazilian.format(new Date(data))

  const formateHour = new Date(data).toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
  })
  const hourAndDateFormateds = `${formatedDate.substr(0, 10)} ${formateHour}`

  return {
    hourAndDateFormateds,
    formatedDate,
    formateHour,
  }
}

const convertDateBrasilForEua = (date: string) => {
  const [day, month, year] = date.split('/')
  const convertedDate = `${year}-${month}-${day}`

  return convertedDate
}

const prettyDateHifen = (date: Date) => {
  const dateValue = new Date(date)
  const year = dateValue.getFullYear()
  const month = String(dateValue.getMonth() + 1).padStart(2, '0')
  const day = String(dateValue.getDate()).padStart(2, '0')

  return `${year}-${month}-${day}`
}

const prettyDate = (date: Date) =>
  date.toLocaleDateString('pt-BR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  })

const prettyDateString = (value = '') =>
  value
    .replace(/\D/g, '')
    .slice(0, 8)
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(-\d{4})\d+?$/, '$1')

const thousandsFormatter = (value: string, separator: string) => {
  const groups = []

  while (value.length > 0) {
    groups.push(value.slice(-3))
    value = value.slice(0, -3)
  }

  return groups.reverse().join(separator)
}

const prettyCurrency = (
  value: number,
  decimalSeparator = ',',
  thousandsSeparator = '.',
) => {
  if (value === undefined || value === null) {
    return ''
  }

  const clearedValue = value.toFixed(2)

  const [thousands, decimal] = clearedValue.split('.')

  const formattedThousands = thousandsFormatter(thousands, thousandsSeparator)
  const signal = value < 0 ? '- ' : ''
  const final = formattedThousands.toString().replace('-', '')

  return `${signal}R$ ${final}${decimalSeparator}${decimal}`
}

const prettyCNPJ = (value = '') => {
  return value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1.$2')
    .replace(/(\d{4})(\d{1,2})/, '$1/$2')
    .replace(/(-\d{2})\d+?$/, '$1')
}

const prettyCPF = (value = '') => {
  return value
    .replace(/\D/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1')
}

const prettyPhone = (value = '') => {
  return value
    .replace(/\D/g, '')
    .slice(0, 11)
    .replace(/(\d{0})(\d)/, '($1$2')
    .replace(/(\d{2})(\d)/, '$1) $2')
    .replace(/(\d{5})(\d)/, '$1 - $2')
}

const prettyTimeString = (value = '') => {
  return value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '$1:$2')
    .replace(/(\d{2})(\d)/, '$1')
}

const prettyZipCode = (value = '') => {
  return value
    .replace(/\D/g, '')
    .replace(/(\d{5})(\d)/, '$1-$2')
    .replace(/(\d{5})(\d)/, '$1')
}

const prettyValidDateCredit = (value = '') =>
  value
    .replace(/\D/g, '')
    .slice(0, 6)
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(-\d{4})\d+?$/, '$1')

const prettyCVCCredit = (value = '') => value.replace(/\D/g, '').slice(0, 4)

const prettyNumberCredit = (value = '') =>
  value
    .replace(/\D/g, '')
    .slice(0, 16)
    .replace(/(\d{4})(\d{4})(\d{4})(\d{4})/, '$1 $2 $3 $4')

const prettyDateBRFormated = (date: string) => {
  const [year, month, day] = date.split('-')
  const convertedDate = `${day}/${month}/${year}`
  return convertedDate
}

const prettyCapitalize = (value: string) => {
  return value
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

export const Formatter = {
  prettyDate,
  prettyDateHifen,
  prettyCurrency,
  prettyCNPJ,
  prettyPhone,
  prettyCPF,
  prettyDateString,
  prettyTimeString,
  prettyZipCode,
  convertDateBrasilForEua,
  prettyValidDateCredit,
  prettyCVCCredit,
  prettyNumberCredit,
  prettyDateBRFormated,
  formatterDateAndHour,
  prettyCapitalize,
}
